import React, { useEffect, useState } from 'react';
import Accordion from '../Accordion';
import './mleMakerChecker.scss';
import MerchantDetailsView from './MerchantDetailsView';
import MleCheckerApprovalForm from './MleCheckerApprovalForm';
import { convertArrayToObject, fetchBasicFormData, filterSectionCheckerData } from './mleMakerChecker.utils';
import { MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';

const BusinessDetailsAccordion = ({ data, additionalData, auth, isViewMode }) => {
  const [checkerRemarksData, setCheckerRemarksData] = useState([]);
  const [fieldsWithViewLink, setFieldsWithViewLink] = useState([]);
  const [basicFormData, setBasicFormData] = useState([]);
  const [transformedData, setTransformedData] = useState({});
  const handleCheckerRemarksData = (updatedData) => {
    setCheckerRemarksData(updatedData);
  };
  
  const checkerData = filterSectionCheckerData(additionalData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.business);
  
  const currentEventType = checkerData?.eventType || '';
  const currentMakerRequestId = checkerData?.makerRequestId || '';
  
  const checkerLevel = checkerData?.approvalLevel || null;
  const remarks = checkerData?.remarks || null;
  const editedFields = checkerData?.editedFields || null;
  

  const levelMapping = {
    L1: 'L2',
    L2: 'L3',
    L3: null, 
  };
  const raisedToLevel = levelMapping[checkerLevel] || null;
  
  
  useEffect(() => {
    // update checker remarks data to json format 
    setTransformedData(checkerData?.checkerRemarks[0])
    fetchBasicFormData(setBasicFormData);
}, []);


  return (
    <div className="ownership-details-accordion">
      {/* <Accordion
        isOpened
        key={`ubo-declaration`}
        customClass="rounded-accordion"
        upperComponent={<h3>Business Details</h3>}
        lowerComponent={ */}
          <MerchantDetailsView
            data={data}
            additionalData={transformedData}
            auth={auth}
            handleCheckerRemarksData={handleCheckerRemarksData}
            isViewMode={isViewMode}
            editedFields={editedFields}
            basicFormData={basicFormData}
          />
        {/* }
      /> */}
      <MleCheckerApprovalForm
        raisedToLevel={raisedToLevel}
        requestDetails={{
          eventType: currentEventType.toUpperCase(),
          makerRequestId: currentMakerRequestId,
          status: additionalData?.status,
          remarks: remarks
        }}
        parentEventType = {additionalData?.eventType}
        checkerRemarks={
          checkerRemarksData && Object.keys(checkerRemarksData).length > 0
            ? checkerRemarksData
            : transformedData
        }
        auth={auth}
        isViewMode={isViewMode}
      />
    </div>
  );
};

export default BusinessDetailsAccordion;
